'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:storage:setItem');
}

var _invoke = require('../invoke');

/**
 * 客户端存储／增、改
 *
 * 客户端调用是异步的，不保证接下去调用 `hbnb.storage.getItem` 能立刻获取最新值
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof storage
 * @static
 * @name setItem
 * @return {Undefined}
 * @example
 *  hbnb.storage.setItem('key', 'value');
 */
module.exports = function(key, val) {
    if (process.env.NODE_ENV !== 'production') {
        debug('key is %s, value is %s', key, val.toString(), val);
    }

    _invoke('storage', 'set_item', {
        key: key,
        value: val.toString()
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/storage/set-item.js
// module id = 240
// module chunks = 10 11 12 13 14 15 16 17 18 19